import AbstractComponent from './AbstractComponent';
import Logger from '../utils/Logger';
import MediaGallery from './MediaGallery';

export default class FilmsGrid extends AbstractComponent {
    constructor(...args) {
        Logger.log('FilmsGrid->constructor()');
        super(...args);

        this.classname = 'c-films-grid';
        this.initDomElements();
        this.addEventListeners();
    }

    initDomElements() {}

    addEventListeners() {
        this.initMediaGallery();
    }

    initMediaGallery() {
        new MediaGallery(this.$el, this.getSelector('__card'));
    }

    destroy() { }
}